import { DateTime } from 'luxon'
import { LabOrderStatus, VideoCallCancelledBy } from 'src/graphql.generated'
import { ActivityFacts } from '../../api/patientConversation'
import { formatEventTime } from '../../format'

// Standard's `formatOrderStatus` (`LabOrderEventItem.tsx`).
const LAB_ORDER_STATUS_LABELS: Record<LabOrderStatus, string> = {
  [LabOrderStatus.Cancelled]: 'Canceled',
  [LabOrderStatus.CollectingSample]: 'Collecting sample',
  [LabOrderStatus.Completed]: 'Completed',
  [LabOrderStatus.Failed]: 'Failed',
  [LabOrderStatus.Received]: 'Received',
  [LabOrderStatus.SampleWithLab]: 'Sample with lab',
}

type VideoCallFacts = Extract<ActivityFacts, { kind: 'videoCall' }>

export const callHasEnded = ({ endTime }: VideoCallFacts): boolean => DateTime.fromISO(endTime) <= DateTime.now()

// Standard's `VideoCallHeader` summary.
const videoCallSummary = (facts: VideoCallFacts): string => {
  const { cancelledAt, cancelledBy, startTime } = facts

  if (cancelledAt) {
    if (!cancelledBy) {
      return 'Cancelled'
    }
    return cancelledBy === VideoCallCancelledBy.Coach ? 'Cancelled by the care team' : 'Cancelled by the participant'
  }
  if (callHasEnded(facts)) {
    return `Had on ${formatEventTime(startTime)}`
  }
  return `Scheduled for ${formatEventTime(startTime)}`
}

export const factsSummary = (facts: ActivityFacts): string => {
  switch (facts.kind) {
    case 'videoCall':
      return videoCallSummary(facts)
    case 'labOrder':
      return LAB_ORDER_STATUS_LABELS[facts.status] ?? 'Unknown'
    case 'overdueQuestionnaire':
      return `Module ${facts.moduleNumber}`
    default: {
      const unhandled: never = facts
      return unhandled
    }
  }
}

// Standard's overdue questionnaire card has nothing to expand.
export const hasFactsBody = (facts: ActivityFacts): boolean => facts.kind !== 'overdueQuestionnaire'
